import {IApiModel} from 'app/original-models/api-model.interface';

export class SlackAuth implements IApiModel<SlackAuth> {
    id?: number;
    teamId: string;
    teamName: string;
    user?: any;

    static getEmptyModel(id: number): SlackAuth {
        return new SlackAuth({
            id: id,
            teamName: '',
            teamId: ''
        });
    }

    constructor(init?: Partial<SlackAuth>) {
        Object.assign(this, init);
    }

    getApiModel(): any {
        return {
            'id': this.id || null,
            'team_id': this.teamId,
            'team_name': this.teamName,
        };
    }

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.teamId = apiModel.team_id;
        this.teamName = apiModel.team_name;
        this.user = apiModel.user || null;
        return this;
    }
}
